import type { ProvisioningJob } from '@/lib/forex-api';

const ownerLabel = { account: '账号资料', platform: '平台', node: '终端节点', operator: '管理员', none: '' };
const actionLabel = { wait: '等待状态更新', resubmit_credentials: '按提示补充账号资料',
  retry: '可重试当前开通任务', contact_operator: '核对原因及未决义务后处理', none: '' };

export default function OnboardingDiagnostic({ diagnostics }: { diagnostics: ProvisioningJob['diagnostics'] }) {
  if (!diagnostics || diagnostics.owner === 'none') return null;
  return <p className="text-xs" data-testid="onboarding-diagnostic">
    处理方：{ownerLabel[diagnostics.owner]}。下一步：{actionLabel[diagnostics.next_action]}
    {diagnostics.blocker_code && <>（{diagnostics.blocker_code}）</>}
  </p>;
}
